import Heading from 'components/heading/heading'
import styles from './page-title.module.scss'
import { cn } from 'utils/helpers'

export default function PageTitle({ children, center }) {
    return (
        <Heading className={cn(center && styles.center, 'mb60')} tag="h1" size="36">
            {children}
        </Heading>
    )
}
